export const CARDFINDER_TRAVEL_BRANCH_PATH = '/credit-cards/cardfinder/travel';

export const ENTITY_NAME = 'travel_newsletter_post_signup';
export const SECTION_NAME = 'post_signup_confirmation';
export const GET_MATCHED_BUTTON_ENTITY_NAME = 'get_matched_button';
export const REDIRECT_DESTINATION = 'cardfinder_travel_branch_entry';
